import React, { Component } from 'react';
import { CCMAddress } from 'ccm-react-components';

// Test: https://esb-t.tccm.org
// Stage: https://esb-s.tccm.org
// Production: https://esb-p.tccm.org
const domain = document.location.host;
var apiUrl = "https://esb-t.tccm.org";

if (domain === "dev.mychristaincare.org") {
    apiUrl = "https://esb-s.tccm.org"
}
if (domain === "mychristaincare.org") {
    apiUrl = "https://esb-p.tccm.org"
}

function applyErrorClass($elm) {
    var cssClass = "";

    if ($elm !== null && $elm.innerHTML !== "") {
        cssClass = "input-validation-error";
    }
    return cssClass;
}

const CCMAddressBlock = () => (
    <CCMAddress
        // Required Props
        muleApiUrl={apiUrl}
        muleClientId={"d125e6fd868c400382b3d0b06b320e31"}
        muleClientSecret={"E852C88188Dc471eBaDa1Be8464E867A"}
        onAddressCollected={
            //(address) => this.onAddressCollected(address)
            function (address) {
                var $inputs = document.querySelectorAll('[data-address-field]');

                for (var i = 0; i < $inputs.length; i++) {
                    var $input = $inputs[i];
                    $input.value = address[$input.getAttribute('data-address-field')];
                }

                document.querySelector('[data-address-validated]').value = address.addressVerified;
            }
        }
        onAddressInvalidated={
            // CCMAddress() => this.onAddressInvalidated()
            function () {
                document.querySelector('[data-address-validated]').value = false;
            }
        }
        // Optional Props
        address={{
            line1: document.querySelector('[data-address-field="line1"]').value,
            city: document.querySelector('[data-address-field="city"]').value,
            state: document.querySelector('[data-address-field="state"]').value,
            zip: document.querySelector('[data-address-field="zip"]').value
        }}
        checkForValidAddressUponMount={false}
        includeGeocodeData={false}
        showProcessingMessages={true}
        showRequiredAsterisks={true}
        style={{
        //   mainWidth:            'override-main-width',
        //   modalWidth:           'override-modal-width',
        //   borderRadius:         'override-border-radius',
        //   generalInputStyle:    'override-input-style',
             line1InputStyle:       applyErrorClass(document.querySelector('[data-valmsg-for="form.Address"]')),
             cityInputStyle:        applyErrorClass(document.querySelector('[data-valmsg-for="form.City"]')),
             stateInputStyle:       applyErrorClass(document.querySelector('[data-valmsg-for="form.State"]')),
             zipInputStyle:         applyErrorClass(document.querySelector('[data-valmsg-for="form.Zip"]'))
        //   requiredAsterisk:     'override-required-asterisk'
        }}
    />
)

function CCMAddressVerification() {
    return <CCMAddressBlock />
}

export default CCMAddressVerification;
